/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Coupon Popup Code reconfigured to use a utm param instead of the deprecated cookie - SLS 051525

if (typeof(window._$) != "undefined") 
    doCouponCookieStuff();
else {
    window.addEventListener('vps:jquery:loaded', doCouponCookieStuff);
}

function doCouponCookieStuff() {
    let _cookie_vps_discount = "vps_discount_code";
    let _cookie_vps_discount_first_view = "vps_discount_first_view";

    let aff_CookieLength = 30;
    let aff_CookieName = "vps_affiliate_last";
    let aff_SourceParamName = "utm_source";
    let aff_MediumParamName = "utm_medium";
    let aff_CampaignParamName = "utm_campaign";
    let discountQueryParamName = "utm_discount_code"; // <== NEW PARAM TO READ

    let suppressUSI = false;

    let _getQueryStringValue = function (_param) {
        let aff_QueryStringPairs = document.location.search.substring(1).split("&");
        for (let i = 0; i < aff_QueryStringPairs.length; i++) {
            let aff_QueryStringParts = aff_QueryStringPairs[i].split("=");
            if (_param.toLowerCase() == aff_QueryStringParts[0].toLowerCase()) {
                return decodeURIComponent(aff_QueryStringParts[1] || '');
            }
        }
    };

    let utm_s = _getQueryStringValue(aff_SourceParamName) || "";
    utm_s = utm_s.toLowerCase();

    if (utm_s === "shopify") utm_s = "";

    if (utm_s) {
        if (utm_s === "awin" || utm_s === "buyat") utm_s = "aw";

        let exp = new Date();
        exp.setDate(exp.getDate() - aff_CookieLength);
        VPSCookieManager.setCookie(aff_CookieName, utm_s, "/", null, true, exp);
    }

    let utm_m = _getQueryStringValue(aff_MediumParamName);
    let utm_c = _getQueryStringValue(aff_CampaignParamName);

    if (utm_m && utm_c && utm_m.toLowerCase() === "email") {
        suppressUSI = true;
    }

    // NEW: Get discount code from URL instead of cookies
    let discountFromURL = _getQueryStringValue(discountQueryParamName);
    if (discountFromURL) {
        discountFromURL = discountFromURL.toUpperCase();
        VPSCookieManager.setCookie(_cookie_vps_discount, discountFromURL);
        VPSCookieManager.setCookie(_cookie_vps_discount_first_view, 1);
    }

    // Use cookie if set from above (or previous session)
    let vpsDiscCookie = VPSCookieManager.getCookie(_cookie_vps_discount);
    let vpsFirstView = VPSCookieManager.getCookie(_cookie_vps_discount_first_view);

    suppressUSI = suppressUSI || (vpsDiscCookie != "");

    let exp = new Date();
    exp.setDate(exp.getDate() + 1);

    if (suppressUSI) {
        VPSCookieManager.setCookie("usi_suppress_preCart_TT", "1", "/", "valuepetsupplies.com", true, "strict", exp);
        VPSCookieManager.setCookie("usi_suppress_activeCart_TT", "1", "/", "valuepetsupplies.com", true, "strict", exp);
    }

    let elem = document.getElementById("discount-message");
    if (elem && vpsDiscCookie) {
        elem.innerHTML = "<span class='herocoupon-green'><b>" + vpsDiscCookie + "</b> Coupon applied</span><span>Discount shown on Checkout page.</span>";
    } else {
        _$('#cart__coupon-container').hide();
    }

    if ((parseInt(vpsFirstView) === 1) && (vpsDiscCookie && vpsDiscCookie.length > 0)) {
        let vpsDiscAmt = vpsDiscCookie.replace(/[^0-9]/g, '');
        if (vpsDiscCookie.substr(0, 3) === "ARD" || vpsDiscCookie.substr(0, 3) === "VRD") {
            vpsDiscAmt = vpsDiscCookie.substr(3, 2);
        }
        _$('#coupon-applied-code').text(vpsDiscAmt);
        _$('#coupon-applied-popup').css('display', 'block');

        setTimeout(function () {
            _$('#coupon-applied-popup').css('display', 'none');
            VPSCookieManager.setCookie(_cookie_vps_discount_first_view, 0);
        }, 1500);
    }
}


// Cookie handler for coupon links on-site

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.apply-discount').forEach(function (el) {
        el.addEventListener('click', function () {
            const discountCode = el.getAttribute('data-discount');

            if (discountCode && typeof VPSCookieManager !== "undefined") {
                const code = discountCode.toUpperCase();
                VPSCookieManager.setCookie("vps_discount_code", code);
                VPSCookieManager.setCookie("discount_code", code);
                VPSCookieManager.setCookie("vps_discount_first_view", 1);
            }
        });
    });
});


// Homepage Learn More Toggle 

var learnMorestatus = "less";
function learnMore() {
  if (learnMorestatus == "less") {
    document.getElementById("home-showmore-section").classList.add("home-showmore-section-visible");
    document.getElementById("home-moreless-button__toggle-text").innerText = "Show Less";
    learnMorestatus = "more";
  } else if (learnMorestatus == "more") {
    document.getElementById("home-showmore-section").classList.remove("home-showmore-section-visible");
    document.getElementById("home-moreless-button__toggle-text").innerText = "Learn More";
    learnMorestatus = "less"
  }
}

// Collections Toggle

 (function() {
        document.addEventListener('DOMContentLoaded', (event) => {
			// Find the element with the class name 'expandable-section'
			const expandableSection = document.querySelector('.expandable-section');
            const expandableToggle = document.querySelector('.expandable-toggle');
            if (expandableSection) {
                expandableSection.parentNode.insertBefore(expandableToggle, expandableSection);
                expandableToggle.classList.add ("expandable-toggle-right");
    			// Add a click event listener to the clickable div
    			expandableToggle.addEventListener('click', function() {
    			// Check the current display style of the 'expandable-section' and toggle it
    			if (expandableSection.style.display === 'none' || expandableSection.style.display === '') {
    			expandableSection.style.display = 'block';
                expandableToggle.classList.remove ("expandable-toggle-right"); 
    			expandableToggle.classList.add ("expandable-toggle-down"); 
    			} else {
    			expandableSection.style.display = 'none';
    			expandableToggle.classList.remove ("expandable-toggle-down"); 
    			expandableToggle.classList.add ("expandable-toggle-right"); 
    			}
    			});
            }
		});
      })();

// AMP Upsell Functions

      function ampAddEcoWidget () {
        const widget = `<eco-widget id="dc0" widget="eyJwYWdlVHlwZSI6ImluX3N0b3JlIiwidmlzaWJsZSI6dHJ1ZSwic2VsZWN0TXVsdGlwbGUiOmZhbHNlLCJ3aWRnZXRLZXkiOiJkZWZhdWx0Iiwic2VsZWN0b3IiOiIucmVidXktY2FydF9fZmx5b3V0LXN1YnRvdGFsIiwicGxhY2VtZW50IjoiYmVmb3JlIiwicGF0aG5hbWUiOiIiLCJ0ZW1wbGF0ZSI6ImNoZWNrb3V0X3dpZGdldCIsIm5hbWUiOiJTaWRlIENhcnQiLCJlbGVtZW50cyI6eyJjb250YWluZXIiOnsic3R5bGVzIjp7Im1hcmdpbiI6IjBweCAwcHggMTBweCAwcHgifX0sImN0YSI6eyJzdHlsZXMiOnsiY29sb3IiOiIjZmZmIn19LCJoZWFkZXIiOnsidGV4dCI6eyJlbiI6IiJ9fSwic3ViSGVhZGVyIjp7ImRpc2FibGUiOnRydWV9fSwiaWQiOiIwIn0=" style="display: block; visibility: visible; z-index: 5; position: relative; outline: none;"></eco-widget>`;
        let htmlObject = document.createElement('div');
        htmlObject.classList.add('ecocart-container');
        htmlObject.innerHTML = widget;
        const ampCartCheckout = document.querySelector('.amp-cart-drawer .amp-cart__footer');
        if (ampCartCheckout) {
          ampCartCheckout.prepend(htmlObject);
        }
      }
      
      function ampResetAtcBtns () {
        document.querySelectorAll('button[name="add"]').forEach(el => el.disabled = false);
      }
      
      function ampFixSubscriptionComparePrice (cart) {
        cart.items.forEach((item, i) => {
          if (!item.selling_plan_allocation) return;
          const compare_at = item.selling_plan_allocation.compare_at_price * item.quantity;
          const el = document.querySelector(`.amp-cart__cart-line:nth-child(${i + 1}) .amp-cart__cart-line-price--original`);
          if (el) {
            const newCompare = new Intl.NumberFormat("en", { style: "currency", currency: Shopify.currency.active, currencyDisplay: "symbol" }).format(compare_at / 100);
            el.textContent = newCompare;
          }
        })
      }
      
      function ampAddComparePrice (itemEl, compareTotal, linePrice) {
        const pricesEl = itemEl.querySelector('.amp-cart__cart-line-price');
        if (!pricesEl) return
        
        const newCompare = new Intl.NumberFormat("en", { style: "currency", currency: Shopify.currency.active, currencyDisplay: "symbol" }).format(compareTotal / 100);
        const newLinePrice = new Intl.NumberFormat("en", { style: "currency", currency: Shopify.currency.active, currencyDisplay: "symbol" }).format(linePrice / 100);
        const newPrices = `
          <div class="amp-cart__cart-line-price--original">${newCompare}</div>
          <div class="amp-cart__cart-line-price--discounted">${newLinePrice}</div>
        `;
        pricesEl.innerHTML = newPrices;
      }
    
      function removeComparePrice (itemEl, linePrice) {
        const existingCompare = itemEl.querySelector('.amp-cart__cart-line-price--discounted');
        const itemPrices = itemEl.querySelector('.amp-cart__cart-line-price');
    
        if (existingCompare && itemPrices) {
          const amount = new Intl.NumberFormat("en", { style: "currency", currency: Shopify.currency.active, currencyDisplay: "symbol" }).format(linePrice / 100);
          itemPrices.innerHTML = amount;
        }
      }
    
      function ampShowComparePrice (cart) {
        cart.items.forEach(async item => {
          if (item.selling_plan_allocation) return;
          const data = await fetch(`/products/${item.handle}.js`).then(res => res.json())
    
          const variant = data.variants.find(i => i.id == item.variant_id);
          const compare = variant.compare_at_price;
          const price = variant.price;
          const img = variant.featured_image ? variant.featured_image.src : data.featured_image;
          const imgEls = document.querySelectorAll(`.amp-cart__cart-line img[src*="${img}"]`)
    
          imgEls.forEach(imgElem => {
            let itemEl = imgElem.parentNode;
            if (!itemEl) return;
            
            const hasDiscountedPrice = itemEl.querySelector('.amp-cart__cart-line-price--discounted') && itemEl.querySelector('.amp-cart__cart-line-price--original')
            if (hasDiscountedPrice) return
    
            if (compare && (compare !== price)) {
              ampAddComparePrice(itemEl, compare * item.quantity, item.line_price);
            } else {
              removeComparePrice(itemEl, item.line_price);
            }
          })
        })
      }

function hideUpsellCartGifts() {
  // hide quantity selector for non-discounted gifts - start
  const cartItemPrices = document.querySelectorAll('.amp-cart__cart-line-price--discounted, .amp-cart__cart-line-price.amp-cart__cart-line-price__no-discount');
  
  cartItemPrices.forEach(price => {
      console.log(price)
      const priceParent = price.closest('.amp-cart__cart-line-details-bottom');
      const quantitySelector = priceParent.querySelector('.amp-cart__line-quantity-selector');

      if (price.textContent === '$0.00') {
        if (quantitySelector) {
          quantitySelector.style.display = 'none';
          priceParent.style.justifyContent = 'flex-end';
        }
      } else {
        quantitySelector.style.display = 'flex';
        priceParent.style.justifyContent = 'space-between';
      }
  });
  // hide quantity selector for non-discounted gifts - end
  
}      


      function ampAddComparePrice (itemEl, compareTotal, linePrice) {
        const pricesEl = itemEl.querySelector('.amp-cart__cart-line-price');
        if (!pricesEl) return
        
        const newCompare = new Intl.NumberFormat("en", { style: "currency", currency: Shopify.currency.active, currencyDisplay: "symbol" }).format(compareTotal / 100);
        const newLinePrice = new Intl.NumberFormat("en", { style: "currency", currency: Shopify.currency.active, currencyDisplay: "symbol" }).format(linePrice / 100);
        const newPrices = `
          <div class="amp-cart__cart-line-price--discounted">${newLinePrice}</div>  
          <div class="amp-cart__cart-line-price--original">${newCompare}</div>          
        `;
        pricesEl.innerHTML = newPrices;
      }
    
      function removeComparePrice (itemEl, linePrice) {
        const existingCompare = itemEl.querySelector('.amp-cart__cart-line-price--discounted');
        const itemPrices = itemEl.querySelector('.amp-cart__cart-line-price');
    
        if (existingCompare && itemPrices) {
          const amount = new Intl.NumberFormat("en", { style: "currency", currency: Shopify.currency.active, currencyDisplay: "symbol" }).format(linePrice / 100);
          itemPrices.innerHTML = amount;
        }
      }
    
      function ampShowComparePrice (cart) {
        cart.items.forEach(async item => {
          const data = await fetch(`/products/${item.handle}.js`).then(res => res.json())
    
          const variant = data.variants.find(i => i.id == item.variant_id);
          const compare = variant.compare_at_price;
          const price = variant.price;
          const img = variant.featured_image ? variant.featured_image.src : data.featured_image;
          const imgEls = document.querySelectorAll(`.amp-cart__cart-line img[src*="${img}"]`)
    
          imgEls.forEach(imgElem => {
            let itemEl = imgElem.parentNode;
            if (!itemEl) return;
            
            const hasDiscountedPrice = itemEl.querySelector('.amp-cart__cart-line-price--discounted') && itemEl.querySelector('.amp-cart__cart-line-price--original')
            if (hasDiscountedPrice) return
    
            if (compare && (compare !== price)) {
              ampAddComparePrice(itemEl, compare * item.quantity, item.line_price);
            } else {
              removeComparePrice(itemEl, item.line_price);
            }
          })
        })
      }
      
      window.AMP_CART_LOADED = cart => {
        setTimeout(hideUpsellCartGifts,1000)
        ampAddEcoWidget();
      }      
      
      window.AMP_CART_UPDATED = (cart, cartTarget) => {
        ampResetAtcBtns();
        setTimeout(hideUpsellCartGifts,1000)
        // show compare-at prices for regular products
        ampShowComparePrice(cart);
        
        // fix compare-at prices for subscription products
        ampFixSubscriptionComparePrice(cart);
        
        document.querySelector('.header__cart-count').innerText = cart.item_count
        const ampDiscountsRow = document.querySelector('.amp-cart-drawer .amp-cart__footer .amp-cart__footer-row-discounts');
        
        if (cartTarget) {
          const newBlocks = cartTarget.blocks.map((block) => {
            if (block.type === "CartLinesBlock") {
              if (ampDiscountsRow) {
                return {
                  ...block,
                  content: {
                    ...block.content,
                    subscriptionWithDiscountButtonText: "Subscribe & Save"
                  },
                }
              } else {
                return {
                  ...block,
                  content: {
                    ...block.content,
                    subscriptionWithDiscountButtonText: "Subscribe & Save 25%"
                  },
                }
              }
            }
            
            return block;
          });
    
          return {
            ...cartTarget,
            blocks: newBlocks,
          }
        }
      }

      document.addEventListener(
      "keydown",
      function (event) {
        if(document.querySelector('.amp-cart--open')){
          AMP_API.CLOSE_CART()
        }
      },
      false
    );

